<klt-section title="AFFO / DPS Yield">
  <div class="graph-box">
    <klt-graph
      [loading]="loading"
      [height]="height"
      [options]="options"
      [titles]="titles"
      (filter)="runFilter($event)"
    >
    </klt-graph>
  </div>
</klt-section>
